import { Immutable } from "immer";
import React, { forwardRef } from "react";

import { Image } from "../../../components/Image";
import { tabFeatureAttributeBlock } from "../elementIDs";
import { ITabFeatureAttributeBlock_AttributeTab } from "../models";

import styles from "./index.module.scss";

type IProps = Immutable<{
    idx: number;
    tab: ITabFeatureAttributeBlock_AttributeTab;
    onClick: () => void;
    isSelected: boolean;
    onKeyDown?: (e: React.KeyboardEvent<HTMLButtonElement>) => void;
}>;

export const TabFeatureAttributeBlockAttributeTabButton = forwardRef<
    HTMLButtonElement,
    IProps
>(({ idx, tab, onClick, isSelected, onKeyDown }, ref) => {
    return (
        <button
            ref={ref}
            className={styles.root}
            id={tabFeatureAttributeBlock.attributeTabButton(tab, idx)}
            type="button"
            role="tab"
            aria-controls={tabFeatureAttributeBlock.attributeTabContent(
                tab,
                idx,
            )}
            tabIndex={isSelected ? 0 : -1}
            aria-selected={isSelected}
            onClick={onClick}
            onKeyDown={onKeyDown}
        >
            <span className={styles.label}>
                {tab.display_name ?? tab.attribute_value}
            </span>
            <div className={styles.iconCircle}>
                <div className={styles.iconBg}>
                    <div className={styles.icon}>
                        <Image alt={tab.icon.title} src={tab.icon.url} />
                    </div>
                </div>
            </div>
        </button>
    );
});
TabFeatureAttributeBlockAttributeTabButton.displayName =
    "TabFeatureAttributeBlockAttributeTabButton";
